import { BindingError } from "../../BindingError.js";
class FilterFieldsCollector {
  constructor(schema, rootFilter) {
    this.schema = schema;
    this.rootFilter = rootFilter;
  }
  collectFields(entity) {
    const result = /* @__PURE__ */ new Set();
    this.collectFieldsInternal(this.rootFilter, entity, [], result);
    return result;
  }
  collectFieldsInternal(filter, entity, path, result) {
    for (const [key, value] of Object.entries(filter)) {
      if (key === "and" || key === "or") {
        if (!Array.isArray(value)) {
          throw new BindingError();
        }
        value?.forEach((it) => this.collectFieldsInternal(it, entity, path, result));
      } else if (key === "not") {
        this.collectFieldsInternal(value, entity, path, result);
      } else {
        const field = entity.fields.get(key);
        if (!field) {
          throw new BindingError(`Invalid field: the name "${key}" does not exist on entity "${entity.name}" in a ${path.length === 0 ? "root" : `path "${path.join(".")}"`} of a following filter:
` + JSON.stringify(this.rootFilter, null, "  "));
        }
        if (field.__typename === "_Column") {
          result.add([...path, key].join("."));
        } else {
          const entity2 = this.schema.getEntity(field.targetEntity);
          this.collectFieldsInternal(value, entity2, [...path, key], result);
        }
      }
    }
  }
}
export {
  FilterFieldsCollector
};
//# sourceMappingURL=FilterFieldsCollector.js.map
